import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from '../../generic/classes/message';
import { ApplicationService } from '../../generic/service/application.service';

/**
 * Show message.
 *
 * @author hillebrand
 */
@Component({
    selector: 'show-message',
    styleUrls: ['./show.message.component.scss'],
    template: `
        <div class="row">
          <div class="col-12">
            <div class="system-dialog system-dialog--{{ message.type }}">
              <svg
                class="icon-confirmation"
                width="21"
                height="21"
                >
                @switch (message.type) {
                  @case ('confirmation') {
                    <use
                    xlink:href="/images/icons/svg-sprite.svg#confirmation"></use>
                  }
                  @case ('warning') {
                    <use
                    xlink:href="/images/icons/svg-sprite.svg#warning"></use>
                  }
                  @case ('error') {
                    <use
                    xlink:href="/images/icons/svg-sprite.svg#error"></use>
                  }
                }
              </svg>
        
              {{ message.text }}
        
              @if (dismissable) {
                <button
                  class="system-dialog__close-button"
                  (click)="message.isShown = true">
                  <svg class="icon-cross-small" width="10" height="10">
                    <use
                    xlink:href="/images/icons/svg-sprite.svg#cross-small"></use>
                  </svg>
                </button>
              }
            </div>
          </div>
        </div>
        `,
    standalone: true,
})
export class ShowMessageComponent {
    message: Message;
    persistent: boolean;
    dismissable: boolean = true;

    constructor(
        private applicationService: ApplicationService,
        private router: Router,
    ) {
        this.message = applicationService.message;
        this.persistent = applicationService.message.isPersistent;
        this.dismissable = applicationService.message.isDismissable;

        // Listen to router events to mark the message as shown
        router.events.subscribe(val => {
            if (applicationService.message && !this.persistent) {
                applicationService.message.isShown = true;
            }
        });
    }
}
